<template>
  <div class="account-modal">
    <div ref="accountEditModal" class="modal fade" data-bs-backdrop="static" id="accountEditModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div class="modal-content bg-primary">
          <div class="modal-header">
            <div v-if="elementType === 'name'">{{ $t("views.account.edit.changeName") }} </div>
            <div v-if="elementType === 'email'">{{ $t("views.account.edit.changeEmail") }} </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body bg-light">
            <div v-if="elementType === 'name'">
              <div class="mb-3">
                <label for="inputNewFirstName" class="form-label">{{ $t("views.account.edit.firstName") }}<span class="text-danger">*</span></label>
                <input v-model="userData.firstName.content" type="text" :class="userData.firstName.error === '' ? 'form-control' : 'form-control is-invalid'"
                  id="inputNewFirstName">
                <div class="invalid-feedback">{{ userData.firstName.error }}</div>
              </div>
              <div class="mb-3">
                <label for="inputNewLastName" class="form-label">{{ $t("views.account.edit.lastName") }}<span class="text-danger">*</span></label>
                <input v-model="userData.lastName.content" type="text" :class="userData.lastName.error === '' ? 'form-control' : 'form-control is-invalid'"
                  id="inputNewLastName">
                <div class="invalid-feedback">{{ userData.lastName.error }}</div>
              </div>
            </div>
            <div v-if="elementType === 'email'">
              <div class="mb-3">
                <label for="inputNewEmail" class="form-label">{{ $t("views.account.edit.email") }}<span class="text-danger">*</span></label>
                <input v-model="userData.email.content" type="email" :class="userData.email.error === '' ? 'form-control' : 'form-control is-invalid'"
                  id="inputNewEmail">
                <div class="invalid-feedback">{{ userData.email.error }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer bg-light">
            <button type="button" class="btn btn-sm btn-outline-secondary me-2" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
            <button @click="saveAccount(elementType)" type="button" class="btn btn-sm btn-primary">{{ $t("general.save") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import * as validation from '@/composables/validation'
import { Modal } from 'bootstrap'
import { useStore } from 'vuex'

// Props definieren
const props = defineProps({
  user: {
    type: Object,
    required: true
  },
  elementType: {
    type: String,
    required: true
  }
})

const store = useStore()

// Modal-Ref
const accountEditModal = ref(null)

// Lokale Datenstruktur
const userData = ref({
  firstName: {
    content: '',
    error: '',
    maxLength: 150,
    validate: ['empty', 'length']
  },
  lastName: {
    content: '',
    error: '',
    maxLength: 150,
    validate: ['empty', 'length']
  },
  email: {
    content: '',
    error: '',
    validate: ['empty', 'email']
  }
})

// Computed aus Props
const elementType = computed(() => props.elementType)

// Modal schließen
const closeModal = () => {
  Modal.getInstance(accountEditModal.value)?.hide()
}

// Speichern
const saveAccount = async () => {
  store.commit('SET_LOADING_STATUS', true)

  const valid = validation.fieldValidation(userData.value)

  if (valid === 0) {
    const elementData = Object.fromEntries(
      Object.entries(userData.value).map(([key, value]) => [key, value.content])
    )

    await store.dispatch('updateUserDetails', elementData)

    closeModal()

    Object.keys(userData.value).forEach(field => {
      userData.value[field].error = ''
    })
  }

  store.commit('SET_LOADING_STATUS', false)
}

onMounted(() => {
  userData.value.firstName.content = props.user.firstName
  userData.value.lastName.content = props.user.lastName
  userData.value.email.content = props.user.email
})
</script>
